/**
 * Function to check if the user clicked on horizontal arrows LEFT/RIGHT
 *
 * @param {KeyboardEvent} event
 * @param {string} event.key
 * @returns {boolean}
 */
export default ({ key }) => ['ArrowLeft', 'ArrowRight'].includes(key);
